var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"line","height":"400","options":_vm.apexChatData.lineChartSimple.chartOptions,"series":_vm.apexChatData.lineChartSimple.series}})}
var staticRenderFns = []

export { render, staticRenderFns }